// Oversetter status fra getConnectStatus til tekst og handling i Stripe-panelet.
// action: 'onboard' → Account Link, 'dashboard' → innlogging til Stripe Express,
// null → ingen knapp.
const VIEWS = {
  not_started: {
    badge:       'Ikke koblet til',
    tone:        'neutral',
    description: 'Koble til Stripe for å få utbetalinger. Det tar rundt fem minutter. Ha legitimasjon og kontonummer klart.',
    buttonLabel: 'Kom i gang med Stripe',
    action:      'onboard',
  },
  incomplete: {
    badge:       'Ikke fullført',
    tone:        'warning',
    description: 'Stripe-oppsettet er ikke fullført, så utbetalinger er ikke aktivert ennå.',
    buttonLabel: 'Fullfør Stripe-oppsett',
    action:      'onboard',
  },
  action_required: {
    badge:       'Krever handling',
    tone:        'warning',
    description: 'Stripe trenger flere opplysninger fra deg før utbetalinger kan fortsette.',
    buttonLabel: 'Oppdater opplysninger',
    action:      'onboard',
  },
  pending: {
    badge:       'Under kontroll',
    tone:        'neutral',
    description: 'Stripe kontrollerer opplysningene dine. Det tar vanligvis fra noen minutter til et par dager.',
    buttonLabel: 'Åpne Stripe-dashboard',
    action:      'dashboard',
  },
  active: {
    badge:       'Aktiv',
    tone:        'success',
    description: 'Utbetalinger er aktivert og sendes ukentlig til bankkontoen din.',
    buttonLabel: 'Åpne Stripe-dashboard',
    action:      'dashboard',
  },
  rejected: {
    badge:       'Avvist',
    tone:        'danger',
    description: 'Stripe har avvist kontoen, så utbetalinger er stoppet. Kontakt support så hjelper vi deg videre.',
    buttonLabel: null,
    action:      null,
  },
};

export function connectPanelView(state) {
  return VIEWS[state] ?? VIEWS.not_started;
}
